import React from 'react';
import { Star, Quote } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { testimonials, companyInfo } from '../mock';

const Testimonials = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}
      <section className="bg-gradient-to-br from-slate-900 to-blue-900 text-white py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">Testimoni Klien</h1>
            <p className="text-xl text-blue-100 mb-8">
              Kepuasan klien adalah prioritas utama kami
            </p>
            <div className="inline-flex items-center bg-white bg-opacity-20 backdrop-blur-sm px-8 py-4 rounded-full">
              <Star className="w-6 h-6 text-amber-400 fill-amber-400 mr-2" />
              <span className="text-3xl font-bold mr-2">{companyInfo.rating}</span>
              <span className="text-blue-100">dari {companyInfo.reviewCount} ulasan</span>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Grid */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {testimonials.map((testimonial) => (
                <Card key={testimonial.id} className="bg-white border-2 border-slate-200 hover:border-blue-400 hover:shadow-xl transition-all duration-300">
                  <CardContent className="p-8">
                    <div className="mb-6">
                      <Quote className="w-10 h-10 text-blue-600 opacity-30" />
                    </div>
                    
                    <div className="flex mb-4">
                      {[...Array(testimonial.rating)].map((_, i) => (
                        <Star key={i} className="w-5 h-5 text-amber-400 fill-amber-400" />
                      ))}
                    </div>
                    
                    <p className="text-slate-700 leading-relaxed mb-6 italic">
                      "{testimonial.comment}"
                    </p>
                    
                    <div className="border-t border-slate-200 pt-4">
                      <p className="font-bold text-slate-900 mb-1">{testimonial.name}</p>
                      <p className="text-sm text-slate-600 mb-2">{testimonial.position}</p>
                      <p className="text-xs text-slate-500">{testimonial.date}</p>
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Trust Indicators */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-slate-900 mb-4">Dipercaya Oleh Berbagai Sektor</h2>
              <p className="text-lg text-slate-600">
                Pengalaman melayani klien dari berbagai industri
              </p>
            </div>
            
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              {[
                'Industri Manufaktur',
                'Properti & Real Estate',
                'Pemerintahan',
                'Pendidikan',
                'Perhotelan',
                'Rumah Sakit',
                'Pusat Perbelanjaan',
                'Perumahan'
              ].map((sector, index) => (
                <div key={index} className="bg-slate-50 p-6 rounded-lg text-center border border-slate-200 hover:border-blue-400 hover:shadow-md transition-all duration-300">
                  <p className="text-slate-700 font-semibold text-sm">{sector}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-blue-600 to-blue-800 text-white">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-3xl font-bold mb-6">Jadilah Bagian dari Klien Puas Kami</h2>
            <p className="text-xl text-blue-100 mb-8">
              Ratusan klien telah mempercayakan proyek mereka kepada kami
            </p>
            <a href="#contact" className="inline-block bg-white text-blue-600 hover:bg-blue-50 px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-300 shadow-lg hover:shadow-xl">
              Konsultasi Gratis
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Testimonials;
